import { Reveal } from "./shared";
import { Server, Headset, ShieldCheck } from "lucide-react";

const chapters = [
  {
    no: "01",
    icon: Server,
    title: "IT Teams",
    desc: "Total infrastructure control. Runs entirely inside your own EC2 instance with full root access, custom SSL, and no third-party data processors in the loop.",
    span: "md:col-span-7",
    image: "https://images.pexels.com/photos/5050305/pexels-photo-5050305.jpeg",
  },
  {
    no: "02",
    icon: Headset,
    title: "Customer Support",
    desc: "Sub-second ticket routing, SLA timers, canned replies and a shared inbox built for teams that live in the queue.",
    span: "md:col-span-5",
    image: null,
  },
  {
    no: "03",
    icon: ShieldCheck,
    title: "Internal Operations",
    desc: "Military-grade data privacy. Every ticket, attachment and audit log stays within your VPC boundary — compliant by architecture, not by promise.",
    span: "md:col-span-12",
    image: "https://images.pexels.com/photos/7035859/pexels-photo-7035859.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="border-b border-white/10 py-24 md:py-40">
    <div className="mx-auto w-full max-w-screen-2xl px-6 md:px-12">
      <Reveal>
        <div className="mb-16 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="label-mono">02 — Built for</span>
            <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold leading-none tracking-tight text-white md:text-5xl">
              One image. Three teams. Zero compromise.
            </h2>
          </div>
          <p className="max-w-sm font-sans text-sm text-neutral-500">
            The AMI ships pre-configured for the three groups that depend on ticketing most.
          </p>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
        {chapters.map((c, i) => {
          const Icon = c.icon;
          return (
            <Reveal key={c.no} delay={i * 0.1} className={c.span}>
              <div
                data-testid={`manifesto-card-${c.no}`}
                className="group relative flex h-full min-h-[280px] flex-col justify-between overflow-hidden border border-white/10 bg-[#0A0A0A] p-8 transition-colors duration-300 hover:border-primary/60"
              >
                {c.image && (
                  <div className="absolute inset-0 opacity-20 transition-opacity duration-500 group-hover:opacity-30">
                    <img
                      src={c.image}
                      alt={c.title}
                      className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/70 to-transparent" />
                  </div>
                )}
                <div className="relative z-10 flex items-start justify-between">
                  <span className="font-mono text-5xl font-bold text-white/10 transition-colors duration-300 group-hover:text-primary/40">
                    {c.no}
                  </span>
                  <Icon className="h-6 w-6 text-primary" strokeWidth={1.5} />
                </div>
                <div className="relative z-10 mt-8">
                  <h3 className="font-display text-2xl font-bold tracking-tight text-white">{c.title}</h3>
                  <p className="mt-3 max-w-md font-sans text-sm leading-relaxed text-neutral-400">{c.desc}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
